// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixLocation from "wix-location";

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function columnStrip10_click(event, $w) {
	//Add your code for this event here: 
	wixLocation.to("https://www.victorzi.com/weddings-invitation",);
}


export function columnStrip28_click(event, $w) {
	//Add your code for this event here: 
	wixLocation.to("https://www.victorzi.com/fine-art-prints",);
}
// export function columnStrip10_click(event, $w) {
// 	//Add your code for this event here: 
// 	wixLocation.to("https://www.victorzi.com/weddings-invitation",);
// }

// $w("#columnStrip10").onClick(function() {
//     wixLocation.to('https://www.victorzi.com/weddings-invitation');
// });


// $w("#columnStrip28").onClick(function() {
//     wixLocation.to('https://www.victorzi.com/fine-art-prints');
// });
